import React from 'react'
import TopBanner from '@web/components/Common/TopBanner'
import localization from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const MyHealthTopBanner = _props => {
  const { t } = _props
  return (
    <div>
      <TopBanner pageName={t('myHealth')} />
    </div>

  )
}

export default withLocalization(MyHealthTopBanner, localization)

